import { Component, Input } from '@angular/core'
import { Router } from '@angular/router'
import { Uuid } from '@ftr/contracts/type/shared'
import { IconLegacyComponent, TooltipModule } from '@ftr/foundation'
import { AppPaths, CourtSystemPaths, SearchParams } from '@ftr/routing-paths'
import { select } from '@ngxs/store'
import { SearchManyState } from '../../store'
import { SearchBarComponent, SearchBarService } from './search-bar'

@Component({
  selector: 'ftr-top-bar-search',
  templateUrl: './top-bar-search.component.html',
  styleUrls: ['./top-bar-search.component.css'],
  imports: [SearchBarComponent, IconLegacyComponent, TooltipModule],
})
export class TopBarSearchComponent {
  @Input() courtSystemId: Uuid
  @Input() isSearching: boolean

  protected searchContext = select(SearchManyState.searchContext)

  constructor(
    private readonly router: Router,
    private readonly searchBarService: SearchBarService,
  ) {}

  navigateToSearchResults(): void {
    this.searchBarService.setLastUrlBeforeSearching(this.router.url)
    const searchUrl = ['', AppPaths.CourtSystem, this.courtSystemId, CourtSystemPaths.Search]
    const searchContext = this.searchContext()
    this.router.navigate(searchUrl, {
      queryParams: {
        [SearchParams.SearchTerm]: searchContext?.searchTerms,
        [SearchParams.EntitiesToSearch]: searchContext?.selectedEntities,
        [SearchParams.SearchPageToken]: searchContext?.pageToken,
      },
    })
  }
}
